import { Pipe, PipeTransform } from '@angular/core';
import { SalesProductType } from './sales-product-type';

@Pipe({
  name: 'salesProductType'
})
export class SalesProductTypePipe implements PipeTransform {

  transform(value: number, productTypes: SalesProductType[]): unknown {
    for(let productType of productTypes){
      if(value == productType.id){
        return productType.name;
      }
    }
    return null;
  }

}
